export default "<mat-spinner [diameter]=\"70\"></mat-spinner>\n\n"